import { DASHBOARD_LIST } from "../../actionTypes/foodVendor";

const intialState = {
  DashboardList: []
};

export default function FoodVendorReducers(state = intialState, action) {
  switch (action.type) {

    case DASHBOARD_LIST:
      return { ...state, DashboardList : action.payload };

    default:
      return state;
  }
}
